import React, { useCallback, useEffect, useState } from 'react';
import { Text, View, ScrollView, Pressable } from 'react-native';

import { debounce } from "lodash";
import { store } from '../../store/store';

import { isObjectNotEmpty } from '../../utils/services/CommonUtils';
import { getCartTotalItemCount } from '../../utils/services/oms/UpsertCartData';
import { GetProductCategories } from '../../utils/services/inventory/FilterProductCategories';

import { IconView } from '../../utils/widgets/CommonWidget/Icons';
import { CommonCartHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { ProductCategoriesListView } from '../../utils/widgets/Inventory/ProductCategoriesListView';

import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from '../../TextStyle';

import FadeTextList from '../../utils/widgets/Animations/FadeTextList';

const ProductCategories = (props) => {

    const [chemistStoreData, setChemistStoreData] = useState({})

    const [cartItemCount, setCartItemCount] = useState(0)
    const [productCategories, setProductCategories] = useState([])

    useEffect(() => {
        const _reduxState: any = store.getState();
        if (isObjectNotEmpty(_reduxState.pharmacyAllData)) {
            setChemistStoreData(_reduxState.pharmacyAllData)
            if (_reduxState.pharmacyAllData['productCategories']) {
                if (productCategories.length != _reduxState.pharmacyAllData['productCategories'].length)
                    setProductCategories(_reduxState.pharmacyAllData['productCategories'])
            }
        }
        cartDataSubscription()
        store.subscribe(() => cartDataSubscription())
        // productCategoryOnFocus()
    }, []);

    const cartDataSubscription = useCallback(debounce(updateCartData, AppTheme.debouceTimeout), [])

    function updateCartData() {
        let cartItemCount = getCartTotalItemCount()
        setCartItemCount(cartItemCount)
    }

    const TextInputView = () => {
        return <Pressable style={[AppStyles.flexRowStart, AppStyles.borderView,
        AppStyles.py12, AppStyles.px16, { width: AppTheme.appWidth - 55 - 44 - 16 }]}
            onPress={() => { navigateToSearchItem(chemistStoreData) }}>
            <IconView icon={'search_blue.svg'} size={18} />
            <Text style={[TextStyle.text14, AppStyles.pl8]}>Search for items...</Text>
        </Pressable>
    }

    const productCategoryOnFocus = () => {
        const { navigation }: any = props;
        navigation.addListener("focus", () => {
            if (global.allowScrollProductCategory) {
                window.scrollTo({
                    top: global.windowScrollListPageYOffset,
                    left: 0, behavior: 'auto'
                })
            } else global.allowScrollProductCategory = false
        });
        navigation.addListener("blur", () => {
            if (!global.allowScrollProductCategory) {
                global.allowScrollProductCategory = true;
            }
        });
    }

    const onSelectCategory = (category) => {
        // global.windowScrollListPageYOffset = scrollY
        props.navigation.navigate(ScreenRoute.search_deals, { category: category })
    }

    const cartNavigation = () => {
        props?.navigation?.navigate(ScreenRoute.cart)
    }

    const navigateToSearchItem = (chemistStoreData) => {
        if (chemistStoreData?.spslEnabled)
            props.navigation.navigate(ScreenRoute.search_deals)
        else props.navigation.navigate(ScreenRoute.search_medicine)
    }

    return <View>

        <CommonCartHeader title={'Product Categories'} cartItemCount={cartItemCount}
            cartNavigation={cartNavigation} navigation={props.navigation} />

        <ScrollView style={[AppStyles.mtHeader, { paddingVertical: 24 }]} showsVerticalScrollIndicator={false}>

            <Pressable onPress={() => { navigateToSearchItem(chemistStoreData) }}
                style={[AppStyles.flexRowStart, AppStyles.borderView, {
                    paddingHorizontal: 16, paddingVertical: 12,
                    alignSelf: "center", width: AppTheme.appWidth - 32
                }]}>
                <IconView size={16} icon={'search_blue.svg'} />
                <Text style={[TextStyle.text16, { marginLeft: 16 }]}>
                    Search for  <FadeTextList /></Text>
            </Pressable>

            {productCategories?.length > 0 ? <ScrollView style={[AppStyles.overflowInherit, { marginHorizontal: 28 }]}>
                <ProductCategoriesListView iconSize={(AppTheme.appWidth - 56 - 32) / 3}
                    categoryList={GetProductCategories(productCategories, {})}
                    action={(category) => onSelectCategory(category)} />
            </ScrollView> : null}

        </ScrollView>

    </View>
}

export default ProductCategories;
